/* eslint-disable max-statements */
export const isOk = (value) => (value === 'ok' ? true : false);

export const isErrorInRow = (original) => {
  const errors = {
    'errorsIndexes': [],
    'errorsMessages': {
      '0': [], '1': [], '2': [], '4': [], '5': [], '6': [], '7': [], '8': [], '16': [], '15': [], '17': [],
    },
  };
  if (!isOk(original.errorExternalColor)) {
    errors.errorsIndexes.push(4);
    errors.errorsMessages[4].push(original.errorExternalColor);
  }
  if (!isOk(original.errorModelInOrigin)) {
    errors.errorsIndexes.push(1);
    errors.errorsMessages[1].push(original.errorModelInOrigin);
  }
  if (!isOk(original.errorInternalColor)) {
    errors.errorsIndexes.push(5);
    errors.errorsMessages[5].push(original.errorInternalColor);
  }
  if (!isOk(original.errorModel)) {
    errors.errorsIndexes.push(2);
    errors.errorsMessages[2].push(original.errorModel);
  }
  if (!isOk(original.errorTotal)) {
    errors.errorsIndexes.push(6);
    errors.errorsMessages[6].push(original.errorTotal);
  }
  if (!isOk(original.errorEquivalence)) {
    errors.errorsIndexes.push(0);
    errors.errorsMessages[0].push(original.errorEquivalence);
  }
  if (!isOk(original.errorOrderNumberExists)) {
    errors.errorsIndexes.push(0);
    errors.errorsMessages[0].push(original.errorOrderNumberExists);
  }
  if (
    !isOk(original.errorRepeatedOriginalOrderNumber) &&
    original.repeatedOriginalOrderNumber.includes(original.originalOrderNumber)) {
    errors.errorsIndexes.push(0);
    errors.errorsMessages[0].push(original.errorRepeatedOriginalOrderNumber);
  }
  if (!isOk(original.errorModelActive)) {
    errors.errorsIndexes.push(1);
    errors.errorsMessages[1].push(original.errorModelActive);
    errors.errorsIndexes.push(2);
    errors.errorsMessages[2].push(original.errorModelActive);
  }
  return errors;
};

export const isCellError = (index, listError) => (listError.includes(index) ? true : false);
